import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmExecutionType } from '../interfaces/IKnmExecutionType';

export async function fetchKnmExecutionTypes(): Promise<IKnmExecutionType[]> {
  return apiGet<IKnmExecutionType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-execution-types`);
}
